module.exports = __webpack_public_path__ + "img/thumbnail_NineBandedArmadillo_f_normal.9833e198.png";